import React, { useCallback, useEffect, useRef } from "react";
import {
  Card,
  useRouteParams,
  useInjector,
  CdsIcon,
  useDetailComponentData,
} from "@bb-vendure/admin-ui/react";
import { timesIcon } from "@cds/core/icon";
import {
  NotificationService,
  ModalService,
  AssetPickerDialogComponent,
  Asset,
  Order,
  I18nService,
} from "@bb-vendure/admin-ui/core";
import { useState } from "react";
import useGetCustomsClearance from "./graphql/Get-Customs-Clearance";
import { useDropzone } from "react-dropzone";
import { Box } from "@mui/material";
import { ICustomsClearance } from "./types";
import useUploadFile from "./graphql/Upload-Image";
import useAddCustomClearanceFiles from "./graphql/Add-Customs-Clearance-Files";
import useRemoveCustomClearanceFiles from "./graphql/Remove-Customs-Clearance-Files";
import CustomsClearanceFileTable from "./CustomsClearanceFileTable";
import useGetCustomsClearanceFiles from "./graphql/get-customs-clearance-files";
import useRequestCustomsClearance from "./graphql/request-customs-clearance";

export default function CustomsClearanceState() {
  const { params } = useRouteParams();
  const id = params?.id;
  const translator = useInjector(I18nService);
  const [uploadFileToServer] = useUploadFile();
  const [addCustomClearanceFiles] = useAddCustomClearanceFiles();
  const [removeCustomsClearanceFile] = useRemoveCustomClearanceFiles();
  const { entity, detailForm } = useDetailComponentData<Order>();
  const [uploadedAssets, setUploadedAssets] = useState<Asset[]>([]);
  const [disableUpload, setDisableUpload] = useState(false);
  const notificationService = useInjector(NotificationService);
  const modalService = useInjector(ModalService);
  const tableRef = useRef<any>();
  const [customsClearance, setCustomsClearance] = useState<
    ICustomsClearance | undefined
  >(undefined);
  const { data, loading, error, refetch } = useGetCustomsClearance(id, false);
  let fetchFilesObject: any;

  const [requestCustomsClearance] = useRequestCustomsClearance();

  // const onDrop = useCallback(
  //   (acceptedFiles: File[]) => {
  //     setUploadedFiles([...uploadedFiles, ...acceptedFiles]);
  //   },
  //   [uploadedFiles]
  // );
  // const { getRootProps, getInputProps, isDragActive } = useDropzone({
  //   (onDrop),
  //   accept: {
  //     "application/pdf": [],
  //   },
  // });

  useEffect(() => {
    if (data) {
      const result = (data as any).customsClearance;
      if (result) {
        setCustomsClearance(result);
      }
    }
  }, [data]);

  if (!customsClearance && !loading) {
    return (
      <div style={{ marginBottom: "1rem" }}>
        <Card title="Customs Clearance">
          <button
            className="btn btn-primary"
            type="button"
            style={{
              marginBottom: "1rem",
            }}
            onClick={(e) => {
              e.preventDefault();

              requestCustomsClearanceAction();
            }}
          >
            Request Customs Clearance
          </button>

          <div> No customs clearance provided</div>
        </Card>
      </div>
    );
  }

  async function uploadCustomsClearanceFile() {
    if (uploadedAssets.length <= 0) {
      return;
    }
    setDisableUpload(true);
    let assets: any[] = [];
    // const uploadData = await uploadFileToServer({
    //   input: uploadedFiles.map((file) => ({
    //     file: file,
    //     tags: ["Customs Clearance"],
    //   })),
    // });

    assets = uploadedAssets;

    const newData = await addCustomClearanceFiles({
      id: customsClearance?.id,
      assetIds: assets.map((asset) => asset.id),
    });

    const result = (newData as any).customsClearance;
    if (result) {
      setCustomsClearance(result);

      //tableRef.current?.refreshTable();
    }

    tableRef.current.refreshTable();

    setUploadedAssets([]);
    setDisableUpload(false);
    notificationService.success("Add new customs clearance file");
  }

  function requestCustomsClearanceAction() {
    requestCustomsClearance({
      orderId: id,
    }).then((res) => {
      if (res) {
        notificationService.success("Request successfully");
      }
    });
  }

  function removeCustomsClearanceFileConfirm(fileId: string) {
    removeCustomsClearanceFile({
      id: customsClearance?.id,
      assetId: fileId,
    }).then(() => {
      notificationService.success("Deleted");
      refetch({
        id: id,
      });
      tableRef.current?.refreshTable();
    });
  }

  return (
    <div style={{ marginBottom: "1rem" }}>
      <Card title={translator.translate("common.customs-clearance")}>
        {loading ? (
          "Loading..."
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div>
              <button
                className="btn btn-primary"
                type="button"
                style={{
                  marginBottom: "1rem",
                }}
                onClick={(e) => {
                  e.preventDefault();

                  //console.log("requested");

                  requestCustomsClearanceAction();
                }}
              >
                {translator.translate("customs-clearance.request")}
              </button>
              <div
                style={{
                  display: "flex",
                }}
              >
                <p
                  style={{
                    marginRight: "8px",
                    marginTop: "0px",
                  }}
                >
                  {translator.translate("common.status")} :
                </p>
                <div className="button-ghost">
                  {customsClearance
                    ? customsClearance.state
                    : "No customs clearance is provided"}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "12px",
                }}
              >
                <p
                  style={{
                    marginRight: "8px",
                    marginTop: "0px",
                  }}
                >
                  {translator.translate("customs-clearance.id-card-status")} :
                </p>
                <div className="button-ghost">
                  {(entity?.customFields as any).idCardStatus}
                </div>
              </div>
            </div>
            {uploadedAssets.length > 0 && (
              <button
                className="button primary"
                onClick={() => {
                  uploadCustomsClearanceFile();
                }}
                disabled={disableUpload}
              >
                {translator.translate("customs-clearance.upload")}
              </button>
            )}
          </div>
        )}

        <div
          style={{
            marginTop: "16px",
          }}
          onClick={(e) => {
            modalService
              .fromComponent(AssetPickerDialogComponent, {
                size: "xl",
              })
              .subscribe((result) => {
                if (result && result.length) {
                  setUploadedAssets([...uploadedAssets, result[0]]);
                }
              });
          }}
          // {...getRootProps()}
        >
          {/* <input {...getInputProps()} /> */}
          {uploadedAssets.length > 0 ? (
            <Box
              component="section"
              sx={{
                pt: 2,
                px: 2,
                pb: 6,
                borderRadius: 5,
                border: "1px dashed grey",
                textAlign: "center",
              }}
            >
              {uploadedAssets.map((upFile, key) => (
                <div
                  key={key}
                  style={{
                    border: "1px solid",
                    padding: "4px",
                    borderRadius: "8px",
                    marginBottom: "6px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                    }}
                  >
                    {upFile.name}
                  </p>
                  <div
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setUploadedAssets(
                        uploadedAssets.filter((file, index) => index !== key)
                      );
                    }}
                  >
                    <CdsIcon icon={timesIcon} size="md" />
                  </div>
                </div>
              ))}
              {translator.translate("common.drag-and-drop")}
            </Box>
          ) : true ? (
            <Box
              component="section"
              sx={{
                p: 2,
                borderRadius: 5,
                border: "1px dashed grey",

                height: "5rem",
                textAlign: "center",
              }}
            >
              {translator.translate("common.drop-pdf-file")}
            </Box>
          ) : (
            <Box
              component="section"
              sx={{
                p: 2,
                borderRadius: 5,
                border: "1px dashed grey",

                height: "5rem",
                textAlign: "center",
              }}
            >
              {translator.translate("common.drag-and-drop")}
            </Box>
          )}
        </div>

        {customsClearance && (
          <div>
            {/* <table
                style={{
                  width: "100%",
                  border: "1px solid",
                  marginTop: "12px",
                  borderCollapse: "collapse",
                }}
              >
                <tr
                  style={{
                    border: "1px solid",
                  }}
                >
                  <th>id</th>
                  <th>name</th>
                  <th>source</th>
                  <th
                    style={{
                      width: "20%",
                    }}
                  >
                    createdAt
                  </th>
                  <th>Action</th>
                </tr>
                {customsClearance.files.map((file, key) => (
                  <tr key={key}>
                    <td
                      style={{
                        border: "1px solid",
                        textAlign: "center",
                      }}
                    >
                      {file.id}
                    </td>
                    <td
                      style={{
                        border: "1px solid",
                      }}
                    >
                      {file.name}
                    </td>
                    <td
                      style={{
                        border: "1px solid",
                      }}
                    >
                      <a
                        style={{
                          color: "blue",
                          fontWeight: "bold",
                          textDecoration: "underline",
                        }}
                        target="_blank"
                        href={file.source}
                      >
                        Open
                      </a>
                    </td>
                    <td
                      style={{
                        border: "1px solid",
                      }}
                    >
                      {new Date(file.createdAt).toLocaleDateString()}
                    </td>
                    <td
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <button
                        className="button danger"
                        onClick={() => {
                          modalService
                            .dialog({
                              title: "Remove a customs clearance file",
                              body: `Are you sure you want to remove "${file.name}"?`,
                              buttons: [
                                { label: "Cancel", type: "secondary" },
                                {
                                  label: "Delete",
                                  type: "danger",
                                  returnValue: true,
                                },
                              ],
                            })
                            .subscribe((result) => {
                              if (result) {
                                removeCustomsClearanceFile({
                                  id: customsClearance.id,
                                  assetId: file.id,
                                }).then(() => {
                                  notificationService.success("Deleted");
                                  refetch({
                                    id: id
                                  });
                                });
                              }
                            });
                        }}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </table> */}

            <CustomsClearanceFileTable
              ref={tableRef}
              refresh={refetch}
              removeCustomsClearanceFile={removeCustomsClearanceFileConfirm}
              id={customsClearance.id}
            />
          </div>
        )}
      </Card>
    </div>
  );
}
